import { z } from 'zod';
// ============================================================================
// NEWSLETTER/WAITLIST SCHEMAS
// ============================================================================
// Request schema for adding email to waitlist
export const AddToWaitlistRequestSchema = z.object({
    email: z.email('Invalid email address').max(255, 'Email too long'),
    captchaToken: z.string().min(1, 'Captcha verification is required'),
    consentToDataProcessing: z.boolean().refine((val) => val === true, {
        message: 'You must consent to data processing to join the waitlist',
    }),
});
